/* eslint-disable */

import moment from "moment";
import { getCurrentUser, getConsumingAssets, unauthorizedError, getOrganizations, getCountries } from "../actions";
import { getRequest, makeCompleteUrlFromLastPart } from "../utils/requestHelper";
import { get29DaysAgoFromDate_YYYYMMDD, dateToYYYYMMDD } from "../utils/date";
import { ACTION_TYPE } from "./ActionTypes";

export const sortAssetsProducing = (
  assetsProducing,
  order,
  orderBy
) => dispatch => {
  dispatch({
    type: "SORT_ASSETS",
    payload: { assetsProducing, order, orderBy }
  });
};

export const setThirtyDayButtonPressed = () => dispatch => {
  dispatch({ type: ACTION_TYPE.ASSET_PRODUCING.THIRTY_DAYS_BUTTON_PRESSED });
};

export const setCustomButtonPressed = () => dispatch => { 
  dispatch({ type: ACTION_TYPE.ASSET_PRODUCING.CUSTOM_BUTTON_PRESSED });
};

export const toggleProdAssetStartDateDialog = () => (dispatch) => {
  dispatch({ type: ACTION_TYPE.ASSET_PRODUCING.TOGGLE_START_DATE_DIALOG });
};

export const toggleProdAssetEndDateDialog = () => (dispatch) => {
  dispatch({ type: ACTION_TYPE.ASSET_PRODUCING.TOGGLE_END_DATE_DIALOG });
};

export const setProdAssetStartDate = (startDate) => (dispatch) => {
  dispatch({ type: ACTION_TYPE.ASSET_PRODUCING.SET_START_DATE, payload: startDate });
};

export const setProdAssetEndDate = (endDate) => (dispatch) => {
  dispatch({ type: ACTION_TYPE.ASSET_PRODUCING.SET_END_DATE, payload: endDate });
};

export const displayProdAssetDateFilter = () => (dispatch) => {
  dispatch({ type: ACTION_TYPE.ASSET_PRODUCING.DISPLAY_DATE_FILTER });
};

export const hideProdAssetDateFilter = () => (dispatch) => {
  dispatch({ type: ACTION_TYPE.ASSET_PRODUCING.HIDE_DATE_FILTER });
};

export const changePage = page => dispatch => {
  dispatch({ type: "CHANGE_PAGE", payload: { page } });
};

export const changeRowsPerPage = rowsPerPage => dispatch => {
  dispatch({ type: "CHANGE_ROWS_PER_PAGE", payload: { rowsPerPage } });
};

export const getAssetsProducing = async () => {
  let url = process.env.REACT_APP_API_URL + "/api/prod";

  const response = await fetch(url, {
    method: "GET",
    credentials: "include"
  });

  let producingAssets = await response.json();

  return producingAssets
};

export const fetchOffchainProducingAsset = async assetId => {
  let url = process.env.REACT_APP_API_URL + "/api/prod/" + assetId;

  return await fetch(url, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json; charset=utf-8"
    }
  })
    .then(handleErrors)
    .then(res => res.json())
    .then(data => {
      return data;
    })
    .catch(error => {
      console.error(error);
    });
};

const getLatestCertificateStartDate = async(assetId) => {
  const GET_LATEST_CERTIFICATE_START_DATE_URL = makeCompleteUrlFromLastPart(`api/prod/last-matched-date/${assetId}`);
  
  let producingAssetLatestCertificateStartDate = await getRequest(GET_LATEST_CERTIFICATE_START_DATE_URL);

  return producingAssetLatestCertificateStartDate;
}

export const fetchAssetProduction = async (prodAssetId, start, end) => {
  //First, we get the producing assets related to this consuming asset

  let url = process.env.REACT_APP_API_URL + "/api/prod/production/" + prodAssetId + "?";
  url += start ? "&start=" + start : "";
  url += end ? "&end=" + end : "";

  return await fetch(url, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json; charset=utf-8"
    }
  })
    .then(handleErrors)
    .then(res => res.json())
    .then(data => {
      return data;
    })
    .catch(error => {
      console.error(error);
    });
};
export const fetchAssetProductionByCertificates = async (prodAssetId, start, end) => {

  let url = process.env.REACT_APP_API_URL + "/api/prod/production/certificate/" + prodAssetId + "?";
  url += start ? "&start=" + start : "";
  url += end ? "&end=" + end : "";

  return await fetch(url, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json; charset=utf-8"
    }
  })
    .then(handleErrors)
    .then(res => res.json())
    .then(data => {
      return data;
    })
    .catch(error => {
      console.error(error);
    });
};

export const fetchProductionByCertificatesForReport = async (start, end, utilityId) => {

  let url = process.env.REACT_APP_API_URL + "/api/prod/report?";
  url += start ? "&start=" + start : "";
  url += end ? "&end=" + end : "";
  url += utilityId ? "&utilityId=" + utilityId : "";

  return await fetch(url, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json; charset=utf-8"
    }
  })
    .then(handleErrors)
    .then(res => res.json())
    .then(data => {
      return data;
    })
    .catch(error => {
      console.error(error);
    });
};

export const getGraphDataProducer = async prodAssetId => {

  let latestCertificateStartDate;
  try{
    latestCertificateStartDate = await getLatestCertificateStartDate(prodAssetId);
  } catch (error) {
    //If most recent certificate date could not be retrieved, consider latestCertificateStartDate to be current date
    latestCertificateStartDate = moment();
  }

  let graphStartDate = get29DaysAgoFromDate_YYYYMMDD(latestCertificateStartDate);
  let graphEndDate = dateToYYYYMMDD(latestCertificateStartDate);

  let productionTimeSeries = await fetchAssetProductionByCertificates(prodAssetId, graphStartDate, graphEndDate);

  let availableProductionData = productionTimeSeries.production.map((value, index) => {
    return value - productionTimeSeries.matchedProduction[index];
  });

  let barChartLabels = productionTimeSeries.dates;
  let barChartData = {
    availableProductionData: availableProductionData,
    matchedProductionData: productionTimeSeries.matchedProduction,
  };

  let graphData = {
    barChartData,
    barChartLabels,
    certificateStatusArray: productionTimeSeries.certificateStatusArray
  };

  return graphData;
};

export const getGraphDataProducerForPeriod = async (prodAssetId, startDate_YYYYMMDD, endDate_YYYYMMDD) => {

  let graphStartDate = startDate_YYYYMMDD;
  let graphEndDate = endDate_YYYYMMDD;

  let productionTimeSeries = await fetchAssetProductionByCertificates(prodAssetId, graphStartDate, graphEndDate);

  let availableProductionData = productionTimeSeries.production.map((value, index) => {
    return value - productionTimeSeries.matchedProduction[index];
  });

  let barChartLabels = productionTimeSeries.dates;
  let barChartData = {
    availableProductionData: availableProductionData,
    matchedProductionData: productionTimeSeries.matchedProduction,
  };

  let graphData = {
    barChartData,
    barChartLabels,
    certificateStatusArray: productionTimeSeries.certificateStatusArray
  };

  return graphData;
};

export const getProducingDataForExport = (startDate, endDate, utilityId) => async dispatch => {

  let reportData = await fetchProductionByCertificatesForReport(startDate, endDate, utilityId);
  return reportData;
};

export const archiveAssetProducingStart = (
  assetProducing,
  history
) => async dispatch => {
  dispatch({ type: "ARCHIVE_ASSET_PRODUCING_START" });

  await archiveAssetProducing(assetProducing).catch(error => {
    dispatch({ type: "ARCHIVE_ASSET_PRODUCING_FAIL" });
    dispatch({
      type: "OPEN_ERROR",
      payload: "Error archiving assetProducing"
    });
  });

  dispatch({ type: "ARCHIVE_ASSET_PRODUCING_SUCCESS" });
  dispatch({ type: "OPEN_SUCCESS", payload: "Asset archived !" });
  history.push("/assets/prod/");
};

const archiveAssetProducing = async assetProducing => {
  return await fetch(
    process.env.REACT_APP_API_URL + "/api/prod/archive/" + assetProducing._id,
    {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    }
  )
    .then(handleErrors)
    .then(res => res.json())
    .then(data => {
      return true;
    })
    .catch(error => error);
};


export const restoreAssetProducingStart = (
  assetProducing,
  history
) => async dispatch => {
  dispatch({ type: "RESTORE_ASSET_PRODUCING_START" });

  await restoreAssetProducing(assetProducing).catch(error => {
    dispatch({ type: "RESTORE_ASSET_PRODUCING_FAIL" });
    dispatch({
      type: "OPEN_ERROR",
      payload: "Error restoring assetProducing"
    });
  });

  dispatch({ type: "RESTORE_ASSET_PRODUCING_SUCCESS" });
  dispatch({ type: "OPEN_SUCCESS", payload: "Asset restored !" });
  history.push("/assets/prod/");
};

const restoreAssetProducing = async assetProducing => {
  return await fetch(
    process.env.REACT_APP_API_URL + "/api/prod/restore/" + assetProducing._id,
    {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    }
  )
    .then(handleErrors)
    .then(res => res.json())
    .then(data => {
      return true;
    })
    .catch(error => error);
};


export const createAssetProducingStart = (
  assetProducing,
  file,
  history,
  sourceHistory
) => async dispatch => {
  if(!assetProducing.organizations || assetProducing.organizations.length < 1 ) {
    dispatch({ type: "OPEN_ERROR", payload: "Please specify at least one organization !" });
    return;
  }

  dispatch({ type: "CREATE_ASSET_PRODUCING_START" });

  // TODO: Refactor this, DB id handling on a front-end event is a very bad practice
  let id = await fetchOffchainMaxProducingAssetId();

  const assetProducingId = id + 1;

  const completeAssetProducing = {
    ...assetProducing,
    id: assetProducingId,
    sourceHistory: sourceHistory
  };

  const createdAsset = await createAssetProducing(completeAssetProducing).catch(
    error => {
      if (error.msg) createAssetProducingFail(error.msg, dispatch);
      else createAssetProducingFail("Error creating asset", dispatch);
    }
  );

  if (createdAsset) {
    if (file) await uploadAssetPicture(file, assetProducingId);

    createAssetProducingSuccess(history, dispatch);
  }
};

export const createAssetProducingSuccess = (history, dispatch) => {
  dispatch({ type: "CREATE_ASSET_PRODUCING_SUCCESS" });
  dispatch({ type: "OPEN_SUCCESS", payload: "New assetProducing created !" });
  history.push("/assets/prod/");
};

export const createAssetProducingFail = (error, dispatch) => {
  dispatch({ type: "OPEN_ERROR", payload: error });
  dispatch({ type: "CREATE_ASSET_PRODUCING_FAIL" });
};

export const updateAssetProducingStart = (
  assetProducing,
  file,
  history,
  sourceHistory
) => async dispatch => {
  if(!assetProducing.organizations || assetProducing.organizations.length < 1 ) {
    dispatch({ type: "OPEN_ERROR", payload: "Please specify an organization !" });
    return;
  }
  
  dispatch({ type: "UPDATE_ASSET_PRODUCING_START" });
  if (file) {
    await uploadAssetPicture(file, assetProducing.id);
  }
  const completeAssetProducing = {
    ...assetProducing,
    sourceHistory: sourceHistory
  };

  const updatedAsset = await instantiateAssetProducing(
    assetProducing.owner,
    completeAssetProducing
  ).catch(error => {
    if (error.msg)
      updateAssetProducingFail(error.msg, completeAssetProducing.id, dispatch);
    else
      updateAssetProducingFail(
        "Error updating asset",
        completeAssetProducing.id,
        dispatch
      );
  });
  if (updatedAsset) {
    updateAssetProducingSuccess(history, dispatch);
  }
};

export const updateAssetProducingSuccess = (history, dispatch) => {
  dispatch({ type: "UPDATE_ASSET_PRODUCING_SUCCESS" });
  dispatch({ type: "OPEN_SUCCESS", payload: "Asset updated !" });
  history.push("/assets/prod/");
};

export const updateAssetProducingFail = (error, assetId, dispatch) => {
  let errorMessage = `${error} .[This message is about asset with id : ${assetId}]`;
  dispatch({ type: "UPDATE_ASSET_PRODUCING_FAIL" });
  dispatch({ type: "OPEN_ERROR", payload: errorMessage });
};

export const getOffchainProdSources = async type => {
  try {
    let response = await fetch(
      process.env.REACT_APP_API_URL + "/api/source/" + type,
      {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json; charset=utf-8"
        }
      }
    );

    handleErrors(response);

    let data = await response.json();

    return data;
  } catch (error) {
    handleCatchedErrors(error);
  }
};

export const getOffchainProdSourceHistory = async assetId => {
  try {
    let response = await fetch(
      process.env.REACT_APP_API_URL + "/api/prod/sourceHistory/" + assetId,
      {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json; charset=utf-8"
        }
      }
    );

    handleErrors(response);

    let data = await response.json();

    return data;
  } catch (error) {
    handleCatchedErrors(error);
  }
};

export const getAssetProducingStart = (assetProducingId, history) => async dispatch => {
  try {
    dispatch({ type: "GET_ASSET_PRODUCING_START" });

    let assetProducing;
  
    assetProducing = await getAssetProducingOffchain(assetProducingId, history, dispatch);
  
    await dispatch(getOrganizations())
    await dispatch(getCountries())
  
    if (assetProducing) {
      dispatch({ type: "GET_ASSET_PRODUCING_SUCCESS", payload: assetProducing });

      dispatch({ type: ACTION_TYPE.ASSET_PRODUCING.THIRTY_DAYS_BUTTON_PRESSED });
  
      const graphDataProducerV2 = await getGraphDataProducer(assetProducingId);
  
      dispatch({
        type: "GET_ASSET_PRODUCING_DATA_SUCCESS",
        payload: graphDataProducerV2
      });
    } else {
      dispatch({ type: "GET_ASSET_PRODUCING_FAIL" });
      history.push("/unauthorized");
      return { status: "unauthorized" };
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: "GET_ASSET_PRODUCING_FAIL"});
    dispatch({ type: ACTION_TYPE.MESSAGE_DIALOG.OPEN_ERROR, payload: "Error during fetching data for asset." });
  }
};
export const getAssetProducingRefresh = (assetProducingId, history, startDate_YYYYMMDD, endDate_YYYYMMDD) => async dispatch => {
  try {
    dispatch({ type: "GET_ASSET_PRODUCING_START" });

    let assetProducing;
  
    assetProducing = await getAssetProducingOffchain(assetProducingId, history, dispatch);
  
    await dispatch(getOrganizations())
    await dispatch(getCountries())
  
    if (assetProducing) {
      dispatch({ type: "GET_ASSET_PRODUCING_SUCCESS", payload: assetProducing });
  
      const graphDataProducerV2 = await getGraphDataProducerForPeriod(assetProducingId, startDate_YYYYMMDD, endDate_YYYYMMDD);
  
      dispatch({
        type: "GET_ASSET_PRODUCING_DATA_SUCCESS",
        payload: graphDataProducerV2
      });
    } else {
      dispatch({ type: "GET_ASSET_PRODUCING_FAIL" });
      history.push("/unauthorized");
      return { status: "unauthorized" };
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: "GET_ASSET_PRODUCING_FAIL"});
    dispatch({ type: ACTION_TYPE.MESSAGE_DIALOG.OPEN_ERROR, payload: "Error during fetching data for asset." });
  }
};

export const getAssetProducingFormStart = assetProducingId => async dispatch => {
  dispatch({ type: "GET_ASSET_PRODUCING_FORM_START" });

  let assetProducing;

  const user = getCurrentUser();
  const userAddress = user.app_metadata.address;
  assetProducing = await getAssetProducing(userAddress, assetProducingId);
  dispatch({
    type: "GET_ASSET_PRODUCING_FORM_SUCCESS",
    payload: assetProducing
  });
};

export const resetCurrentAssetProducing = () => async dispatch => {
  dispatch({ type: "RESET_ASSET_PRODUCING" });
};

export const getAssetProducing = async (sender, assetProducingId) => {
  const assetProducing = await getAssetProducingOffchain(assetProducingId);
  return assetProducing;
};

export const getAssetProducingGeneralData = async (sender, assetId) => {
  return await fetch(
    process.env.REACT_APP_API_URL +
    "/producing-assets/" +
    assetId +
    "?_sender=" +
    sender,
    {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    }
  )
    .then(handleErrors)
    .then(res => res.json())
    .then(data => {
      return data;
    })
    .catch(error => {
      console.error(error);
    });
};

export const getAssetProducingOffchain = async (assetId, history, dispatch) => {
  try {
    const url = process.env.REACT_APP_API_URL + "/api/prod/" + assetId;
    let response = await fetch(url, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    });

    if (response.status === 401) {
      response = await response.json();
      unauthorizedError(response.message, history)(dispatch);
      throw new Error(response.message)
    } else {
      let producingAsset = await response.json();
      return producingAsset;
    }
  } catch (err) {
    console.error(err);
  }
};

export const getAssetProducingProperties = async (sender, assetId) => {
  return await fetch(
    process.env.REACT_APP_API_URL +
    "/producing-assets/" +
    assetId +
    "/properties?_sender=" +
    sender,
    {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    }
  )
    .then(handleErrors)
    .then(res => res.json())
    .then(data => {
      return data;
    })
    .catch(error => {
      console.error(error);
    });
};

export const getAssetProducingLocation = async (sender, assetId) => {
  return await fetch(
    process.env.REACT_APP_API_URL +
    "/producing-assets/" +
    assetId +
    "/location?_sender=" +
    sender,
    {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    }
  )
    .then(handleErrors)
    .then(res => res.json())
    .then(data => {
      return data;
    })
    .catch(error => {
      console.error(error);
    });
};

export const assetNameChanged = name => dispatch => {
  dispatch({
    type: "PROD_ASSET_NAME_CHANGED",
    payload: name
  });
};

export const assetIdChanged = assetID => dispatch => {
  dispatch({
    type: "PROD_ASSET_ASSET_ID_CHANGED",
    payload: assetID
  });
};

export const sourceChanged = source => dispatch => {
  dispatch({
    type: "PROD_ASSET_SOURCE_CHANGED",
    payload: source
  });
};

export const sourceIdChanged = sourceID => dispatch => {
  dispatch({
    type: "PROD_ASSET_SOURCE_ID_CHANGED",
    payload: sourceID
  });
};

export const periodNumberChanged = periodNumber => dispatch => {
  dispatch({
    type: "PROD_ASSET_PERIOD_NUMBER_CHANGED",
    payload: periodNumber
  });
};

export const periodTypeChanged = periodType => dispatch => {
  dispatch({
    type: "PROD_ASSET_PERIOD_TYPE_CHANGED",
    payload: periodType
  });
};

export const prodAssetDisplayGraphDataChanged = displayGraphData => dispatch => {
  dispatch({ type: "DISPLAY_GRAPH_DATA_PRODUCING_CHANGED", payload: displayGraphData });
};

export const prodAssetTimeZoneChanged = timeZone => dispatch => {
  dispatch({ type: "TIME_ZONE_PRODUCING_CHANGED", payload: timeZone });
};

export const getAssetProducingSuccess = (assetId, dispatch) => {
  dispatch({ type: "GET_ASSET_PRODUCING_SUCCESS" });
};

export const getAssetProducingFail = (assetId, dispatch) => {
  dispatch({ type: "GET_ASSET_PRODUCING_FAIL" });
};

export const nameChanged = name => dispatch => {
  dispatch({ type: "PROD_ASSET_NAME_CHANGED", payload: name });
};

export const displayedNameChanged = displayedName => dispatch => {
  dispatch({
    type: "PROD_ASSET_DISPLAYED_NAME_CHANGED",
    payload: displayedName
  });
};

export const prodAssetOrganizationChanged = organizationId => dispatch => {
  dispatch({ type: "PROD_ASSET_ORGANIZATION_CHANGED", payload: organizationId });
};

export const prodAssetOrganizationsChanged = organizations => dispatch => {
  dispatch({ type: "PROD_ASSET_ORGANIZATIONS_CHANGED", payload: organizations });
};

export const prodAssetCountryChanged = countryId => dispatch => {
  dispatch({ type: "PROD_ASSET_COUNTRY_CHANGED", payload: countryId });
};

export const ownerChanged = owner => dispatch => {
  dispatch({ type: "PROD_ASSET_OWNER_CHANGED", payload: owner });
};

export const activeChanged = active => dispatch => {
  dispatch({ type: "ACTIVE_CHANGED", payload: active });
};

export const locationChanged = location => dispatch => {
  dispatch({ type: "LOCATION_CHANGED", payload: location });
};

export const typeChanged = assetType => dispatch => {
  dispatch({ type: "TYPE_CHANGED", payload: assetType });
};

export const registryComplianceChanged = registryCompliance => dispatch => {
  dispatch({
    type: "REGISTRY_COMPLIANCE_CHANGED",
    payload: registryCompliance
  });
};

export const capacityChanged = assetCapacity => dispatch => {
  dispatch({ type: "CAPACITY_CHANGED", payload: assetCapacity });
};

export const operationalSinceChanged = timestamp => dispatch => {
  dispatch({ type: "OPERATIONAL_SINCE_CHANGED", payload: timestamp });
};

const handleErrors = response => {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
};

const handleCatchedErrors = err => {
  throw Error(err);
};

export const getAssetsProducingLength = async sender => {
  return await fetch(
    process.env.REACT_APP_API_URL +
    "/producing-assets-list-length?_sender=" +
    sender,
    {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    }
  )
    .then(handleErrors)
    .then(async res => res.json())
    .then(async assetProducingListLength => {
      return assetProducingListLength;
    })
    .catch(error => {
      console.error(error);
    });
};

export const prodAssetPictureChanged = file => dispatch => {
  dispatch({ type: "PROD_ASSET_PICTURE_CHANGED", payload: file });
};

const uploadAssetPicture = async (file, assetId) => {

  var formData = new FormData();
  formData.append("files", file);

  const res = await fetch(
    process.env.REACT_APP_API_URL + "/api/prod/upload-file/" + assetId,
    {
      method: "POST",
      credentials: "include",
      body: formData
    }
  )
    .then(function (response) {
      return response.json();
    })
    //.then(handleErrors)
    .then(function (body) {
      return body;
    });
};

export const getAssetsProducingStart = (assetId) => async dispatch => {

  try {
    dispatch({ type: "GET_ASSETS_PRODUCING_START" });
    const consumingAssets = await getConsumingAssets();
    const producingAssets = await getAssetsProducing();

      if (assetId === undefined) {
        getAssetsProducingSuccess(producingAssets, dispatch);
        return producingAssets;
      } else {
        let consumingAsset = consumingAssets.find(cA => {
          return parseInt(cA.id) === parseInt(assetId)
        })
        let producingAssetsFiltered = producingAssets.filter(pA => {
          let isRelatedToConsumingAsset = false;
          consumingAsset.producingAssets.map(relatedProdAsset => {
            if(parseInt(relatedProdAsset.id) === parseInt(pA.id) ) isRelatedToConsumingAsset = true
          })

          return isRelatedToConsumingAsset
        })

        getAssetsProducingSuccess(producingAssetsFiltered, dispatch);
        return producingAssetsFiltered;
    }

  }
  catch (err) {
    console.log(err);
  }
};


export const getAssetsProducingSuccess = (assetsProducing, dispatch) => {
  dispatch({ type: "GET_ASSETS_PRODUCING_SUCCESS", payload: assetsProducing });
};

export const getAssetsProducingFail = (error, dispatch) => {
  dispatch({ type: "GET_ASSETS_PRODUCING_FAIL" });
};

const createEmptyAssetProducing = async sender => {
  return await fetch(
    process.env.REACT_APP_API_URL + "/producing-assets?_sender=" + sender,
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    }
  )
    .then(handleErrors)
    .then(res => res.json())
    .then(data => {
      return data;
    })
    .catch(error => error);
};

const instantiateAssetProducing = async (sender, assetProducing) => {
  assetProducing.periodNumber = assetProducing.periodNumber;

  assetProducing.periodType = assetProducing.periodType;

  assetProducing.sourceHistory = assetProducing.sourceHistory;

  const updatedAssetProducing = await setAssetProducing(assetProducing);
  return updatedAssetProducing;
};

const initGeneralAssetProducing = async (sender, assetProducing) => {
  const data = {
    _owner: assetProducing.owner,
    _operationalSince: moment(parseInt(assetProducing.operationalSince)).format(
      "x"
    ),
    _active: assetProducing.active
  };

  const json = JSON.stringify(data);

  return await fetch(
    process.env.REACT_APP_API_URL +
    "/producing-assets/" +
    assetProducing.id +
    "?_sender=" +
    sender,
    {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      body: json
    }
  )
    .then(handleErrors)
    .then(res => res.json())
    .then(data => {
      return true;
    })
    .catch(error => error);
};

const assetInitProducingProperties = async (sender, assetProducing) => {
  const data = {
    _assetType: assetProducing.type,
    _capacityWh: parseInt(assetProducing.capacity),
    _registryCompliance: parseInt(assetProducing.registryCompliance),
    _otherGreenAttributes: assetProducing.otherGreenAttributes,
    _typeOfPublicSupport: assetProducing.typeOfPublicSupport,
    _sender: sender
  };

  const json = JSON.stringify(data);

  return await fetch(
    process.env.REACT_APP_API_URL +
    "/producing-assets/" +
    assetProducing.id +
    "/properties?_sender=" +
    sender,
    {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      body: json
    }
  )
    .then(handleErrors)
    .then(res => res.json())
    .then(data => {
      return true;
    })
    .catch(error => error);
};

const assetInitLocationProducing = async (sender, assetProducing) => {
  var data = {
    _country: assetProducing.country,
    _region: assetProducing.region,
    _zip: assetProducing.zip,
    _city: assetProducing.city,
    _street: assetProducing.street,
    _houseNumber: assetProducing.houseNumber,
    _gpsLatitude: assetProducing.gpsLatitude.toString().replace(".", ","),
    _gpsLongitude: assetProducing.gpsLongitude.toString().replace(".", ",")
  };

  const json = JSON.stringify(data);

  return await fetch(
    process.env.REACT_APP_API_URL +
    "/producing-assets/" +
    assetProducing.id +
    "/location?_sender=" +
    sender,
    {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      body: json
    }
  )
    .then(handleErrors)
    .then(res => res.json())
    .then(data => {
      return true;
    })
    .catch(error => error);
};

const setAssetProducing = async assetProducing => {
  let operationalSince = moment(assetProducing.operationalSince).format("YYYY-MM-DDThh:mm:ss");

  const data = {
    owner: assetProducing.owner,
    organization: assetProducing.organization,
    organizations: assetProducing.organizations,
    countryLink: assetProducing.countryLink,
    displayedName: assetProducing.displayedName,
    operationalSince: operationalSince,
    momentTimezone: assetProducing.momentTimezone,
    active: assetProducing.active,
    displayGraphData: assetProducing.displayGraphData,
    country: assetProducing.country,
    region: assetProducing.region,
    zip: assetProducing.zip,
    city: assetProducing.city,
    street: assetProducing.street,
    houseNumber: assetProducing.houseNumber,
    gpsLatitude: assetProducing.gpsLatitude,
    gpsLongitude: assetProducing.gpsLongitude,
    assetType: assetProducing.assetType,
    capacityWh: parseInt(assetProducing.capacityWh),
    registryCompliance: parseInt(assetProducing.registryCompliance),
    name: assetProducing.name,
    assetID: assetProducing.assetID,
    source: assetProducing.source,
    sourceID: assetProducing.sourceID,
    periodNumber: parseInt(assetProducing.periodNumber),
    periodType: assetProducing.periodType,
    sourceHistory: assetProducing.sourceHistory
  };

  const json = JSON.stringify(data);

  try {
    let response = await fetch(
      process.env.REACT_APP_API_URL + "/api/prod/" + assetProducing._id,
      {
        method: "PUT",
        credentials: "include",
        headers: {
          "Content-Type": "application/json; charset=utf-8"
        },
        body: json
      }
    );

    handleErrors(response);

    let data = await response.json();

    return data;
  } catch (error) {
    handleCatchedErrors(error);
  }
};

const fetchOffchainMaxProducingAssetId = async () => {
  try {
    let response = await fetch(
      process.env.REACT_APP_API_URL + "/api/prod/maxId",
      {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json; charset=utf-8"
        }
      }
    );

    handleErrors(response);

    let data = await response.json();

    return data;
  } catch (error) {
    handleCatchedErrors(error);
  }
};

const createAssetProducing = async assetProducing => {
  const data = {
    id: assetProducing.id,
    name: assetProducing.name,
    assetID: assetProducing.assetID,
    source: assetProducing.source,
    sourceID: assetProducing.sourceID,
    periodNumber: assetProducing.periodNumber,
    periodType: assetProducing.periodType ? assetProducing.periodType : "",
    owner: assetProducing.owner,
    organization: assetProducing.organization,
    organizations: assetProducing.organizations,
    countryLink: assetProducing.countryLink,
    displayedName: assetProducing.displayedName,
    momentTimezone: assetProducing.momentTimezone,
    operationalSince: moment(parseInt(assetProducing.operationalSince)).format(
      "x"
    ),
    active: assetProducing.active,
    displayGraphData: assetProducing.displayGraphData,
    country: assetProducing.country,
    region: assetProducing.region,
    zip: assetProducing.zip,
    city: assetProducing.city,
    street: assetProducing.street,
    houseNumber: assetProducing.houseNumber,
    gpsLatitude: assetProducing.gpsLatitude,
    gpsLongitude: assetProducing.gpsLongitude,
    assetType: assetProducing.assetType ? assetProducing.assetType : "",
    capacityWh: parseInt(assetProducing.capacityWh),
    registryCompliance: assetProducing.registryCompliance
      ? parseInt(assetProducing.registryCompliance)
      : "",
    active: true,
    sourceHistory: assetProducing.sourceHistory
  };

  const json = JSON.stringify(data);
  
  try {
    let response = await fetch(
      process.env.REACT_APP_API_URL + "/api/prod/add",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=utf-8"
        },
        credentials: "include",
        body: json
      }
    );

    handleErrors(response);

    let data = await response.json();

    return data;
  } catch (error) {
    handleCatchedErrors(error);
  }
  
};

export const saveProducingSmartMeterRead = (
  assetProducingId,
  newMeterRead,
  smartMeterDown,
  lastSmartMeterReadFileHash,
  cO2OffsetMeterRead,
  cO2OffsetServiceDown,
  sender,
  account
) => async dispatch => {
  dispatch({ type: "SAVE_PRODUCING_SMART_METER_READ_START" });
  var data = {
    _newMeterRead: newMeterRead,
    _smartMeterDown: smartMeterDown,
    _lastSmartMeterReadFileHash: lastSmartMeterReadFileHash,
    _CO2OffsetMeterRead: cO2OffsetMeterRead,
    _CO2OffsetServiceDown: cO2OffsetServiceDown,
    _account: account
  };

  const json = JSON.stringify(data);

  return await fetch(
    process.env.REACT_APP_API_URL +
    "/producing-assets/" +
    assetProducingId +
    "/smartmeter/read?_sender=" +
    sender,
    {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      body: json
    }
  )
    .then(handleErrors)
    .then(res => res.json())
    .then(data => {
      dispatch({ type: "SAVE_PRODUCING_SMART_METER_READ_SUCCESS" });
      getAssetProducingStart(assetProducingId);
      return data;
    })
    .catch(error => {
      dispatch({ type: "SAVE_PRODUCING_SMART_METER_READ_FAIL" });
      return error;
    });
};



// WEBPACK FOOTER //
// ./src/actions/AssetsProducingActions.js